import style from "../common.scss";

export default [
        { name: 'Blanc', color: style.white },
        { name: 'Bleu arrière-plan', color: style.blueBack },
        { name: 'Bleu clair arrière-plan', color: style.lightBlueBack }
    ];